import CommonImage from "@/components/common/image/CommonImage";
import React from "react";
import Image from "next/image";
import AntImage from "@/components/common/image/AntImage";
import { Empty } from "antd";

export default function Routine({ course }) {
  console.log("course", course);

  return (
    <div className="routine_section">
      {course?.doc ? (
        <>
          <div className="title-area">
            <div className="title-wrap">
              <Image
                src="/images/admission-icon/calender-icon.png"
                alt="Price Tag"
                width={24}
                height={24}
              />
              <h2 className="title">ক্লাস রুটিন</h2>
            </div>
            <a
              href={course?.doc}
              target="_blank"
              rel="noopener noreferrer"
              className="primary-btn"
              download
            >
              ডাউনলোড করুন
            </a>
          </div>
          <div className="routine_card">
            {/* {course?.routine_url &&
         <iframe
          src={course.routine_url}
          title="Routine PDF"
          width="100%"
          height="600px"
          style={{ border: 'none' }}
        />
        } */}

            {course?.routine_image_url && (
              <AntImage
                // src={
                //   course?.routine_image_url ?? "/images/course/routine-image.avif"
                // }
                src={course?.routine_image_url}
                className="routine-img"
                alt="routine Img"
              />
            )}
          </div>
        </>
      ) : (
        <Empty description="কোনো রুটিন পাওয়া যায়নি" />
      )}
    </div>
  );
}
